import IconUserClock from "../../../../components/atoms/IconUserClock"
import { loc } from "../../../../core/utils"
import React from "react"
import { Col } from "react-bootstrap"

export default function BplsPendingScoreContent() {
  return (
    <Col xs={11} sm={10} md={10} lg={6} className="hard-shadow-white-block text-center misc-mono-block">
      <IconUserClock />
      <h1>{loc("bplsPendingScoreTitle")}</h1>
      <p className="mb-4">{loc("bplsPendingScoreText")}</p>
    </Col>
  )
}
